import type { NavigateFunction } from 'react-router-dom';
import { SecondarySidebar, SecondarySidebarSection, type AppLayoutApi } from '@jordan/ui';

const ITEMS = [
  { label: 'Favourites', icon: 'ph-heart', path: '/maxsold/favourites' },
  { label: 'Search', icon: 'ph-magnifying-glass', path: '/maxsold/search' },
  { label: 'Bids', icon: 'ph-crosshair-simple', path: '/maxsold/bids' },
  { label: 'Invoices', icon: 'ph-currency-dollar', path: '/maxsold/invoices' },
] as const;

/**
 * Shared secondary (left) sidebar for the Maxsold section. `activePath` lets a detail page force
 * which nav item is highlighted based on how it was reached (e.g. a lot opened from Favourites keeps
 * "Favourites" active instead of falling back to "Search").
 */
export function maxsoldSidebar(navigate: NavigateFunction, pathname: string, activePath?: string) {
  // Which nav item to highlight: an explicit override, else the section the path belongs to —
  // auction/lot detail pages fall under "Search" unless told otherwise.
  const resolvedActive =
    activePath ??
    (pathname.startsWith('/maxsold/auction') || pathname.startsWith('/maxsold/lot') ? '/maxsold/search' : pathname);
  return function MaxsoldSecondarySidebar(api: AppLayoutApi) {
    const go = (path: string) => {
      navigate(path);
      api.closeSecondarySidebar();
    };
    return (
      <SecondarySidebar title="Maxsold" mobileExpanded={api.secondarySidebarExpanded} onClose={api.closeSecondarySidebar}>
        <SecondarySidebarSection title="Maxsold" flush>
          <ul className="nav nav-sidebar my-2" data-nav-type="accordion">
            {ITEMS.map((it) => {
              const active = it.path === resolvedActive;
              return (
              <li className="nav-item" key={it.path}>
                <a
                  href={it.path}
                  className={`nav-link ${active ? 'active' : ''}`.trim()}
                  onClick={(e) => {
                    e.preventDefault();
                    go(it.path);
                  }}
                >
                  <i className={`${it.icon} me-3`} />
                  {it.label}
                </a>
              </li>
              );
            })}
          </ul>
        </SecondarySidebarSection>
      </SecondarySidebar>
    );
  };
}
